import { Fragment } from "react";
import { FileUploader } from "../FormInput";
import useReimbursementContext from "./useReimbursementContext";

export default function Attachments() {
  const { state, dispatch } = useReimbursementContext();
  const { attachments, reimbursement } = state;

  const handleChange = (arg: React.SetStateAction<Attachment[]>) => {
    const newAttachments = typeof arg === "function" ? arg(attachments) : arg;
    dispatch({ type: "setAttachments", payload: newAttachments });
  };

  return (
    <Fragment>
      <h3>Vedlegg</h3>
      <div className="row">
        <FileUploader
          name="reimbursement[attachments]"
          files={attachments}
          caseId={reimbursement.case_id}
          onChange={handleChange}
          size={8}
        />
      </div>
    </Fragment>
  );
}
